import React, { useState, useEffect, useImperativeHandle } from "react";
import { Select, Tooltip } from "antd";
import "./style.scss";
import { InfoCircleOutlined, DownOutlined, } from "@ant-design/icons";
import CustomTable from "../../../../../../../layout/components/customTable";
import { defaultRootCauseTableScrollPosition } from "../../../../../../../core/constants/tableScrollConstants";
const requestOptions = [
    { value: "Yes", label: "Yes" },
    { value: "No", label: "No" },
    { value: "No Explanation available", label: "No Explanation available" },
];
const RootCauseTable = React.forwardRef(({ data, preAnalysis, componentLevelAnalysis, recommendations, setAIData, onFormDataChange, }, ref) => {
    const [tableData, setTableData] = useState([]);
    useEffect(() => {
        if (data && Array.isArray(data) && data.length > 0) {
            const mappedData = data.map((item) => (Object.assign(Object.assign({}, item), { selectedReasons: item.selectedReasons || [], requireReview: item.requires_review || item.requireReview || "" })));
            setTableData(mappedData);
        }
        else {
            setTableData([]);
        }
    }, [data]);
    const [selectedReasons, setSelectedReasons] = useState({});
    const shouldDisableFields = (requireReview) => {
        return (requireReview === "No" || requireReview === "No Explanation available");
    };
    useImperativeHandle(ref, () => ({
        getTableData: () => {
            return tableData;
        },
    }));
    const handleReasonsChange = (value, recordId, record) => {
        if (value.length > 2)
            return;
        const selectedReasonObjects = value
            .map((reasonText) => record.reasons.find((r) => r.reason === reasonText))
            .filter(Boolean);
        setTableData((prev) => prev.map((item) => item.id === recordId
            ? Object.assign(Object.assign({}, item), { selectedReasons: selectedReasonObjects }) : item));
        onFormDataChange === null || onFormDataChange === void 0 ? void 0 : onFormDataChange();
    };
    const handleOthersData = (value, recordId) => {
        setTableData((prev) => prev.map((item) => item.id === recordId ? Object.assign(Object.assign({}, item), { otherReason: value }) : item));
        onFormDataChange === null || onFormDataChange === void 0 ? void 0 : onFormDataChange();
    };
    const handleRequiresReview = (value, recordId) => {
        setTableData((prev) => prev.map((item) => item.id === recordId ? Object.assign(Object.assign({}, item), { requireReview: value }) : item));
        onFormDataChange === null || onFormDataChange === void 0 ? void 0 : onFormDataChange();
    };
    const columns_componentLevelAnalysis = [
        {
            title: "KPI Components",
            dataIndex: "name",
            fieldName: "name",
            width: 300,
            render: (text) => React.createElement("span", null, text),
        },
        {
            title: "Description",
            dataIndex: "analysis",
            fieldName: "analysis",
            render: (text) => React.createElement("div", { style: {} }, text),
        },
    ];
    const columns_recommendations = [
        {
            title: "Recommendation Area",
            dataIndex: "recommendation_area",
            fieldName: "recommendation_area",
            width: 340,
            render: (text) => React.createElement("span", null, text),
        },
        {
            title: "Recommended Action",
            dataIndex: "recommended_action",
            fieldName: "recommended_action",
            width: 750,
            render: (text) => React.createElement("span", null, text),
        },
        {
            title: "Risk if Not Acted Upon",
            dataIndex: "risk_if_not_acted_upon",
            fieldName: "risk_if_not_acted_upon",
            width: 750,
            render: (text) => React.createElement("span", null, text),
        },
    ];
    const preAnalysisColumns = [
        {
            title: "#",
            fieldName: "index",
            render: (_text, _record, index) => index + 1,
            width: 40,
        },
        {
            title: "Root Cause",
            dataIndex: "rootCause",
            fieldName: "rootCause",
            align: "center",
            render: (text) => React.createElement("span", null, text),
            width: 130,
        },
        {
            title: "Direction",
            dataIndex: "direction",
            fieldName: "direction",
            align: "center",
            render: (text) => React.createElement("span", null, text),
            width: 100,
        },
        {
            title: "Variance %",
            dataIndex: "varianceMateriality",
            fieldName: "varianceMateriality",
            align: "center",
            render: (value) => (React.createElement("span", null,
                value,
                value > 0 ? "%" : "")),
            width: 100,
        },
        {
            title: "Period",
            dataIndex: "period",
            fieldName: "period",
            align: "center",
            render: (text) => React.createElement("span", null, text),
            width: 100,
        },
        {
            title: "Requires Review?",
            dataIndex: "requireReview",
            fieldName: "requireReview",
            width: 250,
            render: (_value, record) => (React.createElement(Select, { value: record.requireReview || undefined, style: { width: "100%" }, placeholder: "Select", options: requestOptions, onChange: (value) => handleRequiresReview(String(value), record.id) })),
        },
        {
            title: (React.createElement("span", null,
                "Reason(s)\u00A0",
                React.createElement(Tooltip, { title: "Maximum 2 selections" },
                    React.createElement(InfoCircleOutlined, { style: { color: "#8c8c8c", cursor: "pointer" } })))),
            dataIndex: "reasons",
            fieldName: "reasons",
            width: 300,
            render: (_, record) => (React.createElement("div", { style: {
                    position: "relative",
                    width: "100%",
                    backgroundColor: shouldDisableFields(record.requireReview)
                        ? "#fafafa"
                        : "white",
                    cursor: shouldDisableFields(record.requireReview)
                        ? "not-allowed !important"
                        : "pointer",
                } },
                React.createElement(Select, { className: shouldDisableFields(record.requireReview)
                        ? "select-not-allowed-custom"
                        : "", mode: "multiple", value: (record.selectedReasons || []).map((r) => r.reason), onChange: (value) => handleReasonsChange(value, record.id, record), style: {
                        width: "100%",
                        cursor: shouldDisableFields(record.requireReview)
                            ? "not-allowed !important"
                            : "pointer",
                    }, maxTagCount: 1, maxTagPlaceholder: (omittedValues) => {
                        // Show omitted reason texts
                        const hiddenValues = omittedValues
                            .map((item) => {
                            const found = record.reasons.find((r) => r.id === item.value);
                            return found ? found.reason : item.value;
                        })
                            .join(", ");
                        return (React.createElement(Tooltip, { title: hiddenValues },
                            React.createElement("span", null,
                                "+",
                                omittedValues.length,
                                "...")));
                    }, placeholder: "Select", disabled: shouldDisableFields(record.requireReview) ? true : false, optionLabelProp: "value", showSearch: false, options: record.reasons.map((reasonObj) => {
                        var _a;
                        return ({
                            label: (React.createElement("span", { style: {
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                } },
                                React.createElement("input", { type: "checkbox", checked: (record.selectedReasons || []).some((r) => r.reason === reasonObj.reason), readOnly: true, className: "custom-checkbox", style: { pointerEvents: "none" } }),
                                React.createElement("span", null, reasonObj.reason))),
                            value: reasonObj.reason,
                            disabled: (((_a = record.selectedReasons) === null || _a === void 0 ? void 0 : _a.length) || 0) >= 2 &&
                                !(record.selectedReasons || []).some((r) => r.reason === reasonObj.reason),
                        });
                    }) }),
                React.createElement("div", { style: {
                        position: "absolute",
                        right: "10px",
                        top: "52%",
                        transform: "translateY(-50%)",
                        pointerEvents: "none",
                        zIndex: 1,
                    } },
                    React.createElement(DownOutlined, { style: { color: "#BFBFBF", fontSize: "12px" } })))),
        },
        {
            title: "Others",
            dataIndex: "others",
            fieldName: "others",
            render: (_value, record) => (React.createElement("textarea", { placeholder: "Enter other reasons", style: {
                    height: "82px",
                    width: "100%",
                    resize: "none",
                    overflow: "auto",
                    padding: "8px",
                    fontSize: "12px",
                    borderRadius: "4px",
                    border: "1px solid #EBEBEB",
                    boxSizing: "border-box",
                    cursor: shouldDisableFields(record.requireReview)
                        ? "not-allowed"
                        : "auto",
                }, defaultValue: record.otherReason || "", disabled: shouldDisableFields(record.requireReview), onBlur: (e) => {
                    handleOthersData(e.target.value, record.id);
                } })),
        },
    ];
    const getColumns = () => {
        if (preAnalysis)
            return preAnalysisColumns;
        if (recommendations)
            return columns_recommendations;
        return columns_componentLevelAnalysis;
    };
    return (React.createElement("div", { className: "root-cause-table-wrapper" },
        React.createElement(CustomTable, { columns: getColumns(), data: preAnalysis ? tableData : data, dataType: "rootCauseTable", scroll: componentLevelAnalysis ? true : false, scrollPosition: defaultRootCauseTableScrollPosition, tableWrapperClassName: "root-cause-table" })));
});
export default RootCauseTable;
